export function computeCreateCategoryHasUnsavedChanges(params: {
  name: string;
  description: string;
  isDetermined: boolean;
  isReported: boolean;
}): boolean {
  const { name, description, isDetermined, isReported } = params;
  return (
    name.trim() !== '' ||
    description.trim() !== '' ||
    isDetermined ||
    isReported
  );
}
